<template>
  <Test2 table-name="sgkfdsgdf dfg" :table-data="tableData"></Test2>
</template>

<script>
import Test2 from './Test2';

export default {
  name: 'DataTable',
  data(){
    return {
      tableData: [
        { id: 1, name: 'John Doe', email: 'johndoe@example.com', status: 'Active' },
        { id: 2, name: 'Jane Smith', email: 'janesmith@example.com', status: 'Inactive' },
        { id: 3, name: 'Bob Johnson', email: 'bobjohnson@example.com', status: 'Active' },
        { id: 4, name: 'Alice Brown', email: 'alicebrown@example.com', status: 'Inactive' },
        { id: 5, name: 'David Lee', email: 'davidlee@example.com', status: 'Active' },
      ]
    }
  },
  components:{
    Test2
  },

};
</script>
